function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.93 11H5.807v2H19.93z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.509 3.5l-8.485 8.485L5.438 13.4l8.485-8.485z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.023 11.985l8.486 8.486 1.414-1.415-8.485-8.485z"
});

var SvgArrowBack = function SvgArrowBack(props) {
  return React.createElement("svg", _extends({
    fill: "currentColor",
    height: 24,
    width: 24
  }, props), _ref, _ref2, _ref3);
};

export default SvgArrowBack;